export const USERS_DOMAIN = 'app/modules/Contents/USERS_DOMAIN';

export const REQUEST_USERS = 'app/modules/Contents/REQUEST_USERS';
export const REQUEST_HOME_COMPANY_USERS = 'app/modules/Contents/REQUEST_HOME_COMPANY_USERS';
export const REQUEST_USER = 'app/modules/Contents/REQUEST_USER';
export const CREATE_USER = 'app/modules/Contents/CREATE_USER';
export const REQUEST_USER_UPDATE = 'app/modules/Contents/REQUEST_USER_UPDATE';
export const REQUEST_USER_PROPERTY_UPDATE = 'app/modules/Contents/REQUEST_USER_PROPERTY_UPDATE';
export const REQUEST_USER_PROPERTY_NAMES = 'app/modules/Contents/REQUEST_USER_PROPERTY_NAMES';
export const REQUEST_USER_AVATAR_UPDATE = 'app/modules/Contents/REQUEST_USER_AVATAR_UPDATE';
export const REQUEST_COUNTRIES = 'app/modules/Contents/REQUEST_COUNTRIES';
export const REQUEST_ADD_USER_ADDRESS = 'app/modules/Contents/REQUEST_ADD_USER_ADDRESS';
export const REQUEST_UPDATE_USER_ADDRESS = 'app/modules/Contents/REQUEST_UPDATE_USER_ADDRESS';
export const REQUEST_DELETE_USER_ADDRESS = 'app/modules/Contents/REQUEST_DELETE_USER_ADDRESS';
export const REQUEST_COMPANIES = 'app/modules/Contents/REQUEST_COMPANIES';
export const REQUEST_ADD_USER_TO_COMPANIES = 'app/modules/Contents/REQUEST_ADD_USER_TO_COMPANIES';
export const REQUEST_DELETE_USER_FROM_COMPANY = 'app/modules/Contents/REQUEST_DELETE_USER_FROM_COMPANY';
export const REQUEST_COMPANY_DOCUMENTS = 'app/modules/Contents/REQUEST_COMPANY_DOCUMENTS';
export const REQUEST_VEHICLE_DOCUMENTS = 'app/modules/Contents/REQUEST_VEHICLE_DOCUMENTS';
export const REQUEST_VEHICLE_INVOICE_DOCUMENT = 'app/modules/Contents/REQUEST_VEHICLE_INVOICE_DOCUMENT';
export const REQUEST_ADD_DOCUMENT = 'app/modules/Contents/REQUEST_ADD_DOCUMENT';
export const REQUEST_ADD_MULTIPLE_DOCUMENTS = 'app/modules/Contents/REQUEST_ADD_MULTIPLE_DOCUMENTS';
export const REQUEST_DELETE_DOCUMENT = 'app/modules/Contents/REQUEST_DELETE_DOCUMENT';
export const REQUEST_USER_FILTER = 'app/modules/Contents/REQUEST_USER_FILTER';
export const REQUEST_USER_FILTER_RESET = 'app/modules/Contents/  REQUEST_USER_FILTER_RESET';
export const UPDATE_USER_FILTERS = 'app/modules/Contents/  UPDATE_USER_FILTERS';
export const APPLY_USER_FILTERS = 'app/modules/Contents/  APPLY_USER_FILTERS';

export const REQUEST_WEBSITE_USER_FILTER = 'app/modules/Contents/REQUEST_WEBSITE_USER_FILTER';
export const EXPORT_DATA = 'app/modules/Contents/EXPORT_DATA';
export const GET_PERMISSIONS = 'app/modules/Contents/GET_PERMISSIONS';
export const UPDATE_PERMISSIONS = 'app/modules/Contents/UPDATE_PERMISSIONS';
export const CHECK_USER_EMAIL = 'app/modules/Contents/CHECK_USER_EMAIL';
export const REQUEST_UPDATE_DOCUMENT_LAYERS = 'app/modules/Contents/REQUEST_UPDATE_DOCUMENT_LAYERS';
export const REQUEST_UPDATE_IMAGE_LAYERS = 'app/modules/Contents/REQUEST_UPDATE_IMAGE_LAYERS';

export const FILTER_DEFAULT_LIMIT = 50;

export const REQUEST_WEBSITE_USER = 'app/modules/Contents/REQUEST_WEBSITE_USER';
export const REQUEST_WEBSITE_USERS = 'app/modules/Contents/REQUEST_WEBSITE_USERS';
export const REQUEST_APPROVE_WEBSITE_USER = 'app/modules/Contents/REQUEST_APPROVE_WEBSITE_USER';
export const REQUEST_DISAPPROVE_WEBSITE_USER = 'app/modules/Contents/REQUEST_DISAPPROVE_WEBSITE_USER';
export const REQUEST_WEBSITE_USER_PROPERTY_UPDATE = 'app/modules/Contents/REQUEST_WEBSITE_USER_PROPERTY_UPDATE';

export const REQUEST_USER_HISTORY = 'app/modules/Contents/REQUEST_USER_HISTORY';
export const UPDATE_USER_HISTORY_FILTER = 'app/modules/Contents/UPDATE_USER_HISTORY_FILTER';
export const UPDATE_USER_HISTORY_SEARCH_STRING = 'app/modules/Contents/UPDATE_USER_HISTORY_SEARCH_STRING';

export const USER_DETAILS_WEBSITE_USER_DATA_CARD = [
  'company_name',
  'company_place',
  'name',
  'surname',
  'email_address',
  'webuser_registration_type',
  'approved_for_website',
  'disapproved_for_website',
  'evaluate_for_website',
  'financial_price_gross_incl_btw_bpm',
  'financial_price_nett_excl_vat_bpm',
  'financial_price_b2c',
  'financial_price_b2b_incl_vat_btpm',
];
